export default __webpack_public_path__ + "static/media/Numerology-and-Mobile-Numbers.a047071e.jpg";